import { styled, Box } from '@mui/material'

const DefaultPainel = styled(Box)(({ theme }) => ({
  background: theme.palette.secondary.bg,
  boxShadow: '-1px -1px 3px rgba(0, 0, 0, 0.1), 3px 3px 3px rgba(0, 0, 0, 0.1)',
  borderRadius: '5px',
  padding: '8px!important',
  [theme.breakpoints.down('md')]: {
    padding: 8
  },
  maxWidth: '95vw',
  margin: '0 auto'
}))

export default DefaultPainel
